import React, { useEffect } from "react";
import HeroSection from "../components/HeroSection";
import InfiniteScrollingBanner from "../components/InfiniteScrollingBanner";
import api from "../api/axiosInstance";

// const items = [
//   // "🔥 Flash sale: 30% off selected items",
//   // "New arrivals — summer collection is here",
//   // "Free shipping on orders over $50",
//   // "Subscribe & get 10% off your first order",
//   // "24/7 Support — chat with us anytime",
//   "Ongoing Tournament: Sponsors Cup Golf Tournament-2025 - From 10'th August to 14'th August 2025 | 🔥 Book your appointment now!",
// ];

const Home = () => {
  const [bannerText, setBannerText] = React.useState("");

  useEffect(() => {
    const fetchBanner = async () => {
      const res = await api.get("/banners/latest");
      setBannerText(res.data?.content || "");
    };
    fetchBanner();
  }, []);

  return (
    <div>
      <HeroSection></HeroSection>
      {/* <InfiniteScrollingBanner
        items={items}
        speed={18} // loop duration in seconds
        heightClass="h-8" // small banner
        className="border-b border-gray-800"
      /> */}
      <InfiniteScrollingBanner
        // text="🏆 Upcoming Tournament: ⚈ Winter Cup Golf Tournament 2025 - From 1'st Oct to 2'nd Oct, 2025 | 🔥 Book your appointment now!"
        text={bannerText}
        speed={20} // seconds for one loop
        heightClass="h-12"
        className="border-b md:text-[30px] border-gray-800"
      />
    </div>
  );
};

export default Home;
